import React, { useEffect, useState } from 'react';
import { Button, ButtonLoader } from '../../components/Button';
import './styles.scss';
import { IoClose } from 'react-icons/io5';
import { MdAddAPhoto } from 'react-icons/md';

const CameraGallery = ({ evidenceId, handleUploadPhotos }) => {
  const [images, setImages] = useState([]);
  const [valuesQuestions, setValuesQuestions] = useState({});
  const [loading, setLoading] = useState(false);
  const isInApp = typeof window.ReactNativeWebView !== 'undefined';

  const handleCapture = () => {
    if (isInApp) {
      window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'OPEN_CAMERA' }));
    } else {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.capture = 'environment';
      input.onchange = () => {
        const file = input.files?.[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64Full = reader.result;
            const base64 = base64Full.split(',')[1];
            const newImage = {
              id: Date.now().toString(),
              base64,
              base64Full,
            };

            setImages((prev) => [...prev, newImage]);
            setValuesQuestions((curr) => {
              const key = `${evidenceId}-images`;
              const existing = curr[key] || [];
              const combined = [...existing, newImage];
              const uniqueById = Array.from(new Map(combined.map((img) => [img.id, img])).values());

              return {
                ...curr,
                [key]: uniqueById,
              };
            });
          };
          reader.readAsDataURL(file);
        }
      };
      input.click();
    }
  };

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'IMAGE_CAPTURED' && data.base64) {
          const newImage = {
            id: Date.now().toString(),
            base64: data.base64,
            base64Full: `data:image/jpeg;base64,${data.base64}`,
          };

          setImages((prev) => [...prev, newImage]);
          setValuesQuestions((curr) => {
            const key = `${evidenceId}-images`;
            const existing = curr[key] || [];
            const combined = [...existing, newImage];
            const uniqueById = Array.from(new Map(combined.map((img) => [img.id, img])).values());

            return {
              ...curr,
              [key]: uniqueById,
            };
          });
        }
      } catch (error) {
        console.error('Erro ao processar mensagem:', error);
      }
    };

    document.addEventListener('message', handleMessage); // Android
    window.addEventListener('message', handleMessage);   // iOS

    return () => {
      document.removeEventListener('message', handleMessage);
      window.removeEventListener('message', handleMessage);
    };
  }, [evidenceId]);

  const handleRemove = (id) => {
    setImages((prev) => prev.filter((img) => img.id !== id));
    setValuesQuestions((curr) => {
      const key = `${evidenceId}-images`;
      const filtered = (curr[key] || []).filter((img) => img.id !== id);
      return {
        ...curr,
        [key]: filtered,
      };
    });
  };

  const handleUpload = async () => {
    try {
      setLoading(true);
      await handleUploadPhotos(images.map((img) => img.base64Full));
    } catch (err) {
      console.error('Erro ao fazer upload:', err);
    } finally {
      setImages([]);
      setValuesQuestions({});
      setLoading(false);
    }
  };

  return (
    <>
      {isInApp && <>
        <Button variant="ghost" hasIcon={<MdAddAPhoto />} label="Tirar Foto" color="primary" handleClick={handleCapture} />
        {evidenceId && valuesQuestions[`${evidenceId}-images`]?.length > 0 && (
          <>
            <h2>Fotos Capturadas</h2>
            <div className="camera-gallery-container">
              <div className="camera-gallery-pictures">
                {valuesQuestions[`${evidenceId}-images`].map((image) => (
                  <div key={image.id} style={{ position: 'relative' }}>
                    <img
                      src={`data:image/jpeg;base64,${image.base64}`}
                      alt="capturada"
                      style={{
                        width: '100%',
                        height: 100,
                        objectFit: 'cover',
                        borderRadius: 8,
                      }}
                    />
                    <button
                      onClick={() => handleRemove(image.id)}
                      className="remove-image-button"
                    >
                      <IoClose />
                    </button>
                  </div>
                ))}
              </div>
              <ButtonLoader
                messageProcess="Fazendo upload..."
                loading={loading}
                label="Upload"
                color="primary"
                handleClick={handleUpload}
              />
            </div>
          </>
        )}
      </>}
    </>
  );
};

export default CameraGallery;
